// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  color: #2E2E2E;

}
html, body, #root, .App {
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;
}

.App {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
}
.alice-carousel__wrapper{
  /* width: 90% !important; */

}
div.alice-carousel{
  width: 90% !important;
  align-items: center !important;
} 
.main_page {
  flex: 1 0 auto;
  overflow-x: hidden;
  /* Remove margin-bottom if you want the footer to touch the content */
}

.footer {
  position: static;
  margin-top: auto;
  width: 100%;
}

.main_page{
  margin-bottom: 100px;
}
button{
  color: #2D5B96 !important;
}
.menuButton{
  color: #fff !important;
} 
a{
  text-decoration: none;
  color: #fff;
}
.css-dkekmf-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected{
  color: white !important;
  background-color: #2D5B96 !important;

}
.breadcrumbs a{
  color: #2D5B96 !important;
}
.breadcrumbs{
  color: #2D5B96 !important;
  /* border-bottom: #2D5B96 1px solid; */
  cursor: pointer;
}
.back {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: auto;
}
@keyframes pulsate {
  0% { box-shadow: 0 0 0 0 rgba(45,91,150, 0.7); }
  70% { box-shadow: 0 0 0 15px rgba(45,91,150, 0); }
  100% { box-shadow: 0 0 0 0 rgba(45,91,150, 0); }
}
.pulsate-anim {
  animation: pulsate 1.5s infinite;
}

.loading {
  width: 250px;
  height: 250px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -125px 0 0 -125px;
}
.loadingTitle{
 width: 100% !important;
 text-align: center !important;
 margin-bottom: 40px !important;
}
.loadingImg {
  max-width: 100% !important;
  height: auto !important;
  display: block !important;
  margin: 0 auto !important;
  border: none !important;
  font-size: 48px;
  color: #2D5B96 !important;
}

.navbar {
  position: fixed;
  top: 0;
  z-index: 10;
  background-color: rgb(225, 238, 255);
  width: 100%;
  
  color: white !important;
  display: flex;
  justify-content: end;
  flex-direction: column;
}
.date{
  color:#2D5B96 !important;
  font-weight: 600 !important;
}
.navbar a {
  color: white !important;
}

.navbarMobile {
  position: fixed;
  z-index: 20 !important;
}

.navbarMobile a {
  color: white !important;

}

.navbar a:focus {
  color: white !important;
}

.navbar_back {
  background-color: #2D5B96;
  position: fixed;
  top: 0;
  z-index: 6;
  height: 50px;
  width: 100%;
}

.appBar div {
  z-index: 20 !important;
}

.appBar {
  z-index: 21 !important;

}

.trapezoid {
  border-bottom: 60px solid #2D5B96;
  border-left: 95px solid transparent;
  height: 0;
  width: 1024px;
  margin-bottom: -90px;
  padding-top: 5px;
  margin-left: 50px;
  z-index: 0;

}

.dot {
  height: 500px;
  width: 1000px;
  background-color: #A5CCFF;
  z-index: 0;
  top: -600px;
  border-top-left-radius: 610px;
  /* 100px of height + 10px of border */
  border-top-right-radius: 610px;
  /* 100px of height + 10px of border */
  border: 10px solid #A5CCFF;
  border-bottom: 0;
  position: relative;
  margin-left: 50%;
}

.mainTrain {
  top: -1200px;
  z-index: 5;
  position: relative;
  margin-left: 50%;
  transform: rotate(-10deg);

}

.logo {
  position: relative;
  left: 0;
  padding-bottom: 50px;
  padding-left: 10px;

}

.cardButton {
  background-color: #2D5B96 !important;
  color: white !important;
  border-radius: 20px !important;
  font-size: 12px !important;
}

.href {
  text-decoration: underline;
  color: #2D5B96;
  line-height: 50px;
  font-size: 20px;
}

.mainText {
  font-size: 20px ;
  text-align: justify;
}

.titleOfPage {
  color: #021526 !important;
  font-weight: bold !important;
  font-size: 48px !important;
}

.titleOfParagraph {
  font-size: 32px ;
  color: #2D5B96;
}

.tableHeader {
  margin-left: 15px !important;
  font-weight: bold !important;
}

.pagination button::selection {
  background-color: #5281B5;
  color: white; 
}

.pagination ul {
  justify-content: center;
}

.articleimg {
  width: 400px;
}

.block_title {
  font-size: 48px !important;
  font-weight: bold !important;
  margin-bottom: 30px !important;
  margin-top: 50px !important;
}

.main_page {
  padding-top: 100px;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}
.mainPageImg{
  object-fit: cover;
  width: 500px;
  height: 300px;
  border-radius: 20px;
  margin: 10px;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.my_input {
  border: none;
  font-size: 16px;
  padding: 5px;
  margin: 5px;

  height: 20px;
}

.my_input:focus {
  border: none !important;
}

.my_input:focus-visible {
  border: none !important;
}

.App-link {
  color: #61dafb;
}

.toolbar {
  justify-content: space-between !important;
}

.novisible {
  display: none !important;
}

.navbarMobile {
  width: 100%;
}

.tabsMobile div {
  padding: 20px;
  background: #5281B5;


}

.bgItemList {
  background-color: #E1EEFF;
}

.mainPageImg {}

.scrollContainer{
  padding: 100px 0 0 0;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.navbarMobile {
  display: none;
}

.search {}

.searchBox:hover {
  transform: scale(1.05);
  transition: transform 0.3s ease-in-out;
}

.btn-border-reveal {
  background-color: transparent;
  color: #2D5B96;

  position: relative;
}

.btn-border-reveal:hover {
  transform: scale(1.05);
  transition: transform 0.3s ease;
}

.btn-border-reveal::after,
.btn-border-reveal::before {
  border-radius: 20px;
  content: "";
  position: absolute;
  width: 0;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #2D5B96;
  transition: width 0.3s ease;
  z-index: -1;
}

.btn-border-reveal:hover::after,
.btn-border-reveal:hover::before {
  width: 100%;
}

.btn-border-reveal:hover {
  color: white;
}
.blockOfMain{
  height: 1px;
  /* margin-bottom: 100px; */
}

@media screen and (min-width: 1800px) {
  /* .dot{
    right: 5%;
  } */
}
@media screen and (min-width: 767px) and (max-width: 910px) {
  .App{
    overflow-x: hidden;
  }

  .scrollContainer{
    padding: 5px 0;
  }
  .mainTrain {
    /* transform: rotate(0deg); */
    width: 100vw;
    height: 600px;
    object-fit: cover;
    position: relative;
    top: -1000px;
    margin-left: 0;
    object-position: left top;

  }
  .boxOfProducts{
    top: -1200px !important;
    margin-bottom: -1200px !important;
  }
  .my_input {
    font-size: 16px;
    z-index: 20;
    padding: 8px 10px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 12px;
    background: #f5f8fa;
    border: 1px solid #d1d5db;
    
  }
  /* .search{
    width: 100vw;;
  } */
  .titleOfPage {
    font-size: 24px !important;
  }

  .mainText {
    font-size: 12px !important;
    margin-top: 200px;
  }
    .dot {
      top: -450px;
    width: 100vw;
    margin-left: 0;
    height: 50vw;
   z-index: 0 !important;
  }
}
.search input{
  font-size: 16px !important;
}

@media screen and (min-width: 576px) and (max-width: 767px){
  .mainTrain {
    /* transform: rotate(0deg); */
    top: -1400px;

  }
  .dot{
    top: -700px;
  }
  .boxOfProducts{
    top: -1500px !important;
    margin-bottom: -1500px !important;
  }
}

@media screen and (max-width:  576px){
  .mainTrain {
    /* transform: rotate(0deg); */
    top: -1200px;
    margin-left: 0;

  }
  .dot{
    top: -500px;
    margin-left: 0;
  }
  .boxOfProducts{
    top: -1300px !important;
    margin-bottom: -1400px !important;
  }

}

@media screen and (max-width: 1280px){
  .mainText {
    font-size: 16px !important;
  }

  .titleOfPage {
    font-size: 36px !important;
  }

  .navbar {
    display: none;
  }

  .navbarMobile {
    display: block;
  }

  .main_page {
    padding-top: 0;
  }




  .mainPageImg {
    max-width: 300px;
  }

  .tabsScroll div {
    width: 400px;
    overflow-x: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,cAAc;;AAEhB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,2BAA2B;;AAE7B;AACA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,qEAAqE;AACvE;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,oCAAoC;;AAEtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;AAChB;AACA;EACE,KAAK,wCAAwC,EAAE;EAC/C,MAAM,yCAAyC,EAAE;EACjD,OAAO,sCAAsC,EAAE;AACjD;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;AACA;CACC,sBAAsB;CACtB,6BAA6B;CAC7B,8BAA8B;AAC/B;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,oCAAoC;EACpC,WAAW;;EAEX,uBAAuB;EACvB,aAAa;EACb,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;;AAEzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,MAAM;EACN,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;;AAExB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;;AAEZ;;AAEA;EACE,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,qCAAqC;EACrC,8BAA8B;EAC9B,qCAAqC;EACrC,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;;AAE3B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,oBAAoB;EACpB,kBAAkB;;AAEpB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;;EAEX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;;;AAGrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;;AAEd;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA,SAAS;;AAET;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,cAAc;;EAEd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE;;KAEG;AACL;AACA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,yBAAyB;;EAE3B;EACA;IACE,uBAAuB;IACvB,iCAAiC;EACnC;EACA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;;EAE3B;EACA;;KAEG;EACH;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;IACE;MACE,WAAW;IACb,YAAY;IACZ,cAAc;IACd,YAAY;GACb,qBAAqB;EACtB;AACF;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,6BAA6B;IAC7B,YAAY;;EAEd;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,YAAY;IACZ,cAAc;;EAEhB;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,iCAAiC;EACnC;;AAEF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;;;;EAKA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":[".App {\n  color: #2E2E2E;\n\n}\nhtml, body, #root, .App {\n  height: 100%;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  scroll-behavior: smooth;\n}\n\n.App {\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n}\n.alice-carousel__wrapper{\n  /* width: 90% !important; */\n\n}\ndiv.alice-carousel{\n  width: 90% !important;\n  align-items: center !important;\n} \n.main_page {\n  flex: 1 0 auto;\n  overflow-x: hidden;\n  /* Remove margin-bottom if you want the footer to touch the content */\n}\n\n.footer {\n  position: static;\n  margin-top: auto;\n  width: 100%;\n}\n\n.main_page{\n  margin-bottom: 100px;\n}\nbutton{\n  color: #2D5B96 !important;\n}\n.menuButton{\n  color: #fff !important;\n} \na{\n  text-decoration: none;\n  color: #fff;\n}\n.css-dkekmf-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected{\n  color: white !important;\n  background-color: #2D5B96 !important;\n\n}\n.breadcrumbs a{\n  color: #2D5B96 !important;\n}\n.breadcrumbs{\n  color: #2D5B96 !important;\n  /* border-bottom: #2D5B96 1px solid; */\n  cursor: pointer;\n}\n.back {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  overflow: auto;\n}\n@keyframes pulsate {\n  0% { box-shadow: 0 0 0 0 rgba(45,91,150, 0.7); }\n  70% { box-shadow: 0 0 0 15px rgba(45,91,150, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(45,91,150, 0); }\n}\n.pulsate-anim {\n  animation: pulsate 1.5s infinite;\n}\n\n.loading {\n  width: 250px;\n  height: 250px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -125px 0 0 -125px;\n}\n.loadingTitle{\n width: 100% !important;\n text-align: center !important;\n margin-bottom: 40px !important;\n}\n.loadingImg {\n  max-width: 100% !important;\n  height: auto !important;\n  display: block !important;\n  margin: 0 auto !important;\n  border: none !important;\n  font-size: 48px;\n  color: #2D5B96 !important;\n}\n\n.navbar {\n  position: fixed;\n  top: 0;\n  z-index: 10;\n  background-color: rgb(225, 238, 255);\n  width: 100%;\n  \n  color: white !important;\n  display: flex;\n  justify-content: end;\n  flex-direction: column;\n}\n.date{\n  color:#2D5B96 !important;\n  font-weight: 600 !important;\n}\n.navbar a {\n  color: white !important;\n}\n\n.navbarMobile {\n  position: fixed;\n  z-index: 20 !important;\n}\n\n.navbarMobile a {\n  color: white !important;\n\n}\n\n.navbar a:focus {\n  color: white !important;\n}\n\n.navbar_back {\n  background-color: #2D5B96;\n  position: fixed;\n  top: 0;\n  z-index: 6;\n  height: 50px;\n  width: 100%;\n}\n\n.appBar div {\n  z-index: 20 !important;\n}\n\n.appBar {\n  z-index: 21 !important;\n\n}\n\n.trapezoid {\n  border-bottom: 60px solid #2D5B96;\n  border-left: 95px solid transparent;\n  height: 0;\n  width: 1024px;\n  margin-bottom: -90px;\n  padding-top: 5px;\n  margin-left: 50px;\n  z-index: 0;\n\n}\n\n.dot {\n  height: 500px;\n  width: 1000px;\n  background-color: #A5CCFF;\n  z-index: 0;\n  top: -600px;\n  border-top-left-radius: 610px;\n  /* 100px of height + 10px of border */\n  border-top-right-radius: 610px;\n  /* 100px of height + 10px of border */\n  border: 10px solid #A5CCFF;\n  border-bottom: 0;\n  position: relative;\n  margin-left: 50%;\n}\n\n.mainTrain {\n  top: -1200px;\n  z-index: 5;\n  position: relative;\n  margin-left: 50%;\n  transform: rotate(-10deg);\n\n}\n\n.logo {\n  position: relative;\n  left: 0;\n  padding-bottom: 50px;\n  padding-left: 10px;\n\n}\n\n.cardButton {\n  background-color: #2D5B96 !important;\n  color: white !important;\n  border-radius: 20px !important;\n  font-size: 12px !important;\n}\n\n.href {\n  text-decoration: underline;\n  color: #2D5B96;\n  line-height: 50px;\n  font-size: 20px;\n}\n\n.mainText {\n  font-size: 20px ;\n  text-align: justify;\n}\n\n.titleOfPage {\n  color: #021526 !important;\n  font-weight: bold !important;\n  font-size: 48px !important;\n}\n\n.titleOfParagraph {\n  font-size: 32px ;\n  color: #2D5B96;\n}\n\n.tableHeader {\n  margin-left: 15px !important;\n  font-weight: bold !important;\n}\n\n.pagination button::selection {\n  background-color: #5281B5;\n  color: white; \n}\n\n.pagination ul {\n  justify-content: center;\n}\n\n.articleimg {\n  width: 400px;\n}\n\n.block_title {\n  font-size: 48px !important;\n  font-weight: bold !important;\n  margin-bottom: 30px !important;\n  margin-top: 50px !important;\n}\n\n.main_page {\n  padding-top: 100px;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n.mainPageImg{\n  object-fit: cover;\n  width: 500px;\n  height: 300px;\n  border-radius: 20px;\n  margin: 10px;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.my_input {\n  border: none;\n  font-size: 16px;\n  padding: 5px;\n  margin: 5px;\n\n  height: 20px;\n}\n\n.my_input:focus {\n  border: none !important;\n}\n\n.my_input:focus-visible {\n  border: none !important;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.toolbar {\n  justify-content: space-between !important;\n}\n\n.novisible {\n  display: none !important;\n}\n\n.navbarMobile {\n  width: 100%;\n}\n\n.tabsMobile div {\n  padding: 20px;\n  background: #5281B5;\n\n\n}\n\n.bgItemList {\n  background-color: #E1EEFF;\n}\n\n.mainPageImg {}\n\n.scrollContainer{\n  padding: 100px 0 0 0;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.navbarMobile {\n  display: none;\n}\n\n.search {}\n\n.searchBox:hover {\n  transform: scale(1.05);\n  transition: transform 0.3s ease-in-out;\n}\n\n.btn-border-reveal {\n  background-color: transparent;\n  color: #2D5B96;\n\n  position: relative;\n}\n\n.btn-border-reveal:hover {\n  transform: scale(1.05);\n  transition: transform 0.3s ease;\n}\n\n.btn-border-reveal::after,\n.btn-border-reveal::before {\n  border-radius: 20px;\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background-color: #2D5B96;\n  transition: width 0.3s ease;\n  z-index: -1;\n}\n\n.btn-border-reveal:hover::after,\n.btn-border-reveal:hover::before {\n  width: 100%;\n}\n\n.btn-border-reveal:hover {\n  color: white;\n}\n.blockOfMain{\n  height: 1px;\n  /* margin-bottom: 100px; */\n}\n\n@media screen and (min-width: 1800px) {\n  /* .dot{\n    right: 5%;\n  } */\n}\n@media screen and (min-width: 767px) and (max-width: 910px) {\n  .App{\n    overflow-x: hidden;\n  }\n\n  .scrollContainer{\n    padding: 5px 0;\n  }\n  .mainTrain {\n    /* transform: rotate(0deg); */\n    width: 100vw;\n    height: 600px;\n    object-fit: cover;\n    position: relative;\n    top: -1000px;\n    margin-left: 0;\n    object-position: left top;\n\n  }\n  .boxOfProducts{\n    top: -1200px !important;\n    margin-bottom: -1200px !important;\n  }\n  .my_input {\n    font-size: 16px;\n    z-index: 20;\n    padding: 8px 10px;\n    width: 100%;\n    box-sizing: border-box;\n    border-radius: 12px;\n    background: #f5f8fa;\n    border: 1px solid #d1d5db;\n    \n  }\n  /* .search{\n    width: 100vw;;\n  } */\n  .titleOfPage {\n    font-size: 24px !important;\n  }\n\n  .mainText {\n    font-size: 12px !important;\n    margin-top: 200px;\n  }\n    .dot {\n      top: -450px;\n    width: 100vw;\n    margin-left: 0;\n    height: 50vw;\n   z-index: 0 !important;\n  }\n}\n.search input{\n  font-size: 16px !important;\n}\n\n@media screen and (min-width: 576px) and (max-width: 767px){\n  .mainTrain {\n    /* transform: rotate(0deg); */\n    top: -1400px;\n\n  }\n  .dot{\n    top: -700px;\n  }\n  .boxOfProducts{\n    top: -1500px !important;\n    margin-bottom: -1500px !important;\n  }\n}\n\n@media screen and (max-width:  576px){\n  .mainTrain {\n    /* transform: rotate(0deg); */\n    top: -1200px;\n    margin-left: 0;\n\n  }\n  .dot{\n    top: -500px;\n    margin-left: 0;\n  }\n  .boxOfProducts{\n    top: -1300px !important;\n    margin-bottom: -1400px !important;\n  }\n\n}\n\n@media screen and (max-width: 1280px){\n  .mainText {\n    font-size: 16px !important;\n  }\n\n  .titleOfPage {\n    font-size: 36px !important;\n  }\n\n  .navbar {\n    display: none;\n  }\n\n  .navbarMobile {\n    display: block;\n  }\n\n  .main_page {\n    padding-top: 0;\n  }\n\n\n\n\n  .mainPageImg {\n    max-width: 300px;\n  }\n\n  .tabsScroll div {\n    width: 400px;\n    overflow-x: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
